import { render, staticRenderFns } from "./RemainStock.vue?vue&type=template&id=4e5621fd&scoped=true&"
import script from "./RemainStock.vue?vue&type=script&lang=ts&"
export * from "./RemainStock.vue?vue&type=script&lang=ts&"
import style0 from "./RemainStock.vue?vue&type=style&index=0&id=4e5621fd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5621fd",
  null
  
)

export default component.exports